import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import tourReducer from "./slices/tourSlice";
import feedbackReducer from "./slices/feedbackSlice";
import categoryReducer from "./slices/categorySlice";
import paymentReducer from "./slices/paymentSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { combineReducers } from "redux";
import messagesReducer from "./slices/messagesSlice";
// Kết hợp reducers
const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  tour: tourReducer,
  category: categoryReducer,
  feedback: feedbackReducer,
  payment: paymentReducer,
  messages: messagesReducer,
});

// Cấu hình persist cho toàn bộ reducer
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Chỉ lưu trạng thái `auth`
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer, // ✅ Sử dụng reducer đã được persist
});

export const persistor = persistStore(store);
export default store;
